module.exports = __webpack_public_path__ + "media/svg-new/avatar-4 1-54225f41.svg";